import { render, staticRenderFns } from "./RestablecerContraseña.vue?vue&type=template&id=59855517"
import script from "./RestablecerContraseña.vue?vue&type=script&lang=js"
export * from "./RestablecerContraseña.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports